import { useContext } from 'react';

import { CaptchaContext } from '../CaptchaContext/CaptchaContext';

export const useCaptcha = () => useContext(CaptchaContext);
